<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">1868</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="c1868 in c1868s" :key="c1868.id" :item="c1868" :nextLink="'/download/c1868/' + c1868.id"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'C1868s',
  components: {
    ItemCard
  },
  data () {
    return {
      c1868s: null
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.c1868s = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchC1868s', { categoryID: this.$route.params.category_id, subCategory: this.$route.params.sub_category_name })
        .then((result) => {
          this.c1868s = result.data.c1868s
          $('.overlay').addClass('d-none')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/C1868s.vue